import type { SystemSettings } from '@/types';

/**
 * Admin-controlled operational settings.
 * The dashboard must read durations, ratios and lists from here instead of
 * inventing fixed values in the UI. Replaced by the admin settings API later.
 */
export const systemSettings: SystemSettings = {
  currency: 'ر.س',
  currencyCode: 'SAR',
  otpValidityMinutes: 10,
  manualAssignmentGraceMinutes: 30,
  upload: {
    accept: '.pdf,.jpg,.jpeg,.png',
    maxSizeMB: 10,
  },
  imageUpload: {
    accept: '.png,.jpg,.jpeg,.webp',
    maxSizeMB: 5,
  },
  // Admin-configured execution durations shown in FB03. Replaced by the
  // admin settings API; set a value to null if the admin has not defined it.
  durations: {
    normalHours: 48,
    urgentHours: 24,
  },
  // System finance settings (FB07). commissionRate is an example value that
  // comes from the system; the UI never lets the laundry edit it.
  finance: {
    commissionRate: 0.15,
  },
  // Admin-defined password policy (FB10). Example values from the system.
  password: {
    minLength: 8,
  },
  cities: [
    {
      id: 'riyadh',
      name: 'الرياض',
      districts: [
        'النخيل',
        'الياسمين',
        'العقيق',
        'حطين',
        'الملقا',
        'الصحافة',
        'الربوة',
        'السليمانية',
        'الملز',
        'النرجس',
      ],
    },
    {
      id: 'jeddah',
      name: 'جدة',
      districts: ['الشاطئ', 'الروضة', 'الحمراء', 'السلامة', 'الزهراء'],
    },
    {
      id: 'dammam',
      name: 'الدمام',
      districts: ['الشاطئ', 'المزروعية', 'الفيصلية', 'النور'],
    },
  ],
  additionalDocuments: ['شهادة الزكاة والتأمينات', 'رخصة البلدية'],
};